import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  {
    path: "/Products",
    name: "Products",
    component: () => import("../views/Product/Products.vue"),
  },
  {
    path: "/PurchaseOrders",
    name: "Purchases",
    component: () => import("../views/PurchaseOrder/PurchaseOrders.vue"),
  },
  {
    path: "/PurchaseOrders/:id",
    name: "Purchase",
    component: () => import("../views/PurchaseOrder/PurchaseOrder.vue"),
  },
  {
    path: "/PurchaseReceive",
    name: "PurchasesReceive",
    component: () => import("../views/PurchaseOrder/PurchaseOrders.vue"),
  },
  {
    path: "/PurchaseReceive/:id",
    name: "PurchaseReceive",
    component: () => import("../views/PurchaseOrder/PurchaseOrder.vue"),
  },
  {
    path: "/PurchaseSuggestion",
    name: "Purchases",
    component: () =>
      import("../views/PurchaseSuggestion/PurchaseSuggestion.vue"),
  },
  {
    path: "/Products/:id",
    name: "EditProduct",
    component: () => import("../views/Product/EditProduct.vue"),
  },
  {
    path: "/Orders",
    name: "Orders",
    component: () => import("../views/Order/Orders.vue"),
  },
  {
    path: "/Orders/:id",
    name: "Order",
    component: () => import("../views/Order/Order.vue"),
  },
  {
    path: "/Users",
    name: "Users",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin/Users.vue"),
  },
  {
    path: "/Settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin/Settings.vue"),
  },
  {
    path: "/StockOverview",
    name: "StockOverview",
    component: () => import("../views/Stock/StockOverview.vue"),
  },
  {
    path: "/StockCountings",
    name: "StockCountings",
    component: () => import("../views/Stock/StockCountings.vue"),
  },
  {
    path: "/StockCountings/:id",
    name: "StockCounting",
    component: () => import("../views/Stock/StockCounting.vue"),
  },
  {
    path: "/StockTransactions",
    name: "StockTransactions",
    component: () => import("../views/Stock/StockTransactions.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
